import type { ThemeTemplate } from "../types";

// English comment: Mother's Day theme (soft family photo book starter).
export const THEME_MOTHERS_DAY: ThemeTemplate = {
  id: "theme_mothers_day",
  name: "Dzien Matki",
  target_physical_pages: 64,
  single_first: [
    { type: "shape", shape_id: "rectangle", box: { x: 0.08, y: 0.08, w: 0.84, h: 0.84 }, fill_hex: "#F9E1E7" },
    { type: "image", box: { x: 0.18, y: 0.16, w: 0.64, h: 0.44 }, maskShapeId: "heart" },
    { type: "text", role: "heading", box: { x: 0.12, y: 0.66, w: 0.76, h: 0.12 }, text: "Dzien Matki" },
    { type: "text", role: "body", box: { x: 0.18, y: 0.8, w: 0.64, h: 0.08 }, text: "Najpiekniejsze wspomnienia" }
  ],
  single_last: [
    { type: "shape", shape_id: "rectangle", box: { x: 0.1, y: 0.1, w: 0.8, h: 0.8 }, fill_hex: "#FFF7ED" },
    { type: "text", role: "heading", box: { x: 0.14, y: 0.24, w: 0.72, h: 0.16 }, text: "Kochamy Cie" },
    { type: "text", role: "body", box: { x: 0.18, y: 0.46, w: 0.64, h: 0.24 }, text: "Dziekujemy za kazdy usmiech, troske i dom pelny ciepla." },
    { type: "image", box: { x: 0.34, y: 0.72, w: 0.32, h: 0.16 }, maskShapeId: "heart" }
  ],
  spread_cycle: [
    [
      { type: "image", anchor: "both", bleed: true, box: { x: 0, y: 0, w: 1, h: 1 } },
      { type: "shape", shape_id: "rectangle", anchor: "left", box: { x: 0.1, y: 0.68, w: 0.68, h: 0.18 }, fill_hex: "#FFFFFF" },
      { type: "text", role: "heading", anchor: "left", box: { x: 0.14, y: 0.71, w: 0.6, h: 0.08 }, text: "Nasza Mama" },
      { type: "text", role: "body", anchor: "left", box: { x: 0.14, y: 0.8, w: 0.6, h: 0.04 }, text: "Chwila, do ktorej wracamy" }
    ],
    [
      { type: "image", anchor: "left", box: { x: 0.12, y: 0.12, w: 0.8, h: 0.76 } },
      { type: "shape", shape_id: "rectangle", anchor: "right", box: { x: 0.08, y: 0.12, w: 0.76, h: 0.76 }, fill_hex: "#FCE7F3" },
      { type: "text", role: "heading", anchor: "right", box: { x: 0.14, y: 0.2, w: 0.64, h: 0.14 }, text: "Za Twoje serce" },
      { type: "text", role: "body", anchor: "right", box: { x: 0.14, y: 0.42, w: 0.64, h: 0.28 }, text: "Za cierpliwosc, dobre slowo i wszystkie male rzeczy, ktore znacza najwiecej." }
    ],
    [
      { type: "image", anchor: "left", box: { x: 0.1, y: 0.12, w: 0.82, h: 0.36 } },
      { type: "image", anchor: "left", box: { x: 0.1, y: 0.54, w: 0.82, h: 0.34 }, maskShapeId: "heart" },
      { type: "image", anchor: "right", box: { x: 0.08, y: 0.12, w: 0.82, h: 0.36 }, maskShapeId: "heart" },
      { type: "image", anchor: "right", box: { x: 0.08, y: 0.54, w: 0.82, h: 0.34 } }
    ],
    [
      { type: "shape", shape_id: "rectangle", anchor: "both", box: { x: 0.06, y: 0.08, w: 0.88, h: 0.84 }, fill_hex: "#FFF1F2" },
      { type: "text", role: "heading", anchor: "both", box: { x: 0.16, y: 0.2, w: 0.68, h: 0.16 }, text: "Najcieplejsze wspomnienia" },
      { type: "text", role: "body", anchor: "both", box: { x: 0.2, y: 0.44, w: 0.6, h: 0.24 }, text: "Miejsce na list, zyczenia albo kilka slow od calej rodziny." },
      { type: "image", anchor: "both", box: { x: 0.4, y: 0.72, w: 0.2, h: 0.12 }, maskShapeId: "heart" }
    ],
    [
      { type: "image", anchor: "left", box: { x: 0.1, y: 0.14, w: 0.8, h: 0.64 }, maskShapeId: "heart" },
      { type: "text", role: "heading", anchor: "left", box: { x: 0.16, y: 0.82, w: 0.68, h: 0.08 }, text: "Rodzinne chwile" },
      { type: "image", anchor: "right", box: { x: 0.08, y: 0.14, w: 0.82, h: 0.32 } },
      { type: "image", anchor: "right", box: { x: 0.08, y: 0.54, w: 0.82, h: 0.32 } }
    ],
    [
      { type: "shape", shape_id: "rectangle", anchor: "left", box: { x: 0.08, y: 0.12, w: 0.78, h: 0.72 }, fill_hex: "#FEF3C7" },
      { type: "text", role: "heading", anchor: "left", box: { x: 0.16, y: 0.22, w: 0.62, h: 0.12 }, text: "Dziekujemy" },
      { type: "text", role: "body", anchor: "left", box: { x: 0.16, y: 0.42, w: 0.62, h: 0.28 }, text: "Za dom, w ktorym zawsze jest miejsce na rozmowe, smiech i przytulenie." },
      { type: "image", anchor: "right", box: { x: 0.08, y: 0.12, w: 0.84, h: 0.72 } },
      { type: "text", role: "body", anchor: "right", box: { x: 0.14, y: 0.86, w: 0.72, h: 0.05 }, text: "Twoja ulubiona fotografia" }
    ]
  ]
};
